import { OffersStore } from '@/state/OffersStore';
import { SocketRequest } from '@/config/socket';
import { notify } from '@/helpers/index';

export const useOffers = () => {
  const create_advert = async (payload: any) => {
    OffersStore.set_is_adding_advert(true);
    try {
      const response = await SocketRequest('create_advert', { data: payload });
      if (response?.data) {
        OffersStore.add_advert(response?.data);
      }
    } catch (error) {
      notify('error', 'Failed to create advert');
    } finally {
      OffersStore.set_is_adding_advert(false);
    }
  };

  const remove_advert = async (id: string, index: number) => {
    OffersStore.set_is_fetching_advert(true);
    try {
      const response = await SocketRequest('remove_advert', { data: id });
      if (response?.data) {
        OffersStore.delete_advert(index);
      }
    } catch (error) {
      notify('error', 'Failed to remove advert');
    } finally {
      OffersStore.set_is_fetching_advert(false);
    }
  };

  const edit_advert = async (payload: any) => {
    OffersStore.set_is_fetching_survey(true);
    try {
      const response = await SocketRequest('edit_advert', { data: payload });
      if (response?.data) {
        OffersStore.set_edit_advert(response?.data);
      }
    } catch (error) {
      notify('error', 'Failed to edit advert');
    } finally {
      OffersStore.set_is_fetching_survey(false);
    }
  };

  const get_adverts = async () => {
    OffersStore.set_is_fetching_advert(true);
    try {
      const response = await SocketRequest('get_adverts', { data: {} });
      if (response?.data) {
        OffersStore.set_advert(response?.data);
      }
    } catch (error) {
      notify('error', 'Failed to get adverts');
    } finally {
      OffersStore.set_is_fetching_advert(false);
    }
  };

  // survey thunks
  const create_survey = async (payload: any) => {
    OffersStore.set_is_adding_survey(true);
    try {
      const response = await SocketRequest('create_survey', { data: payload });
      if (response?.data) {
        OffersStore.add_survey(response?.data);
      }
    } catch (error) {
      notify('error', 'Failed to create survey');
    } finally {
      OffersStore.set_is_adding_survey(false);
    }
  };

  const remove_survey = async (id: string, index: number) => {
    OffersStore.set_is_fetching_survey(true);
    try {
      const response = await SocketRequest('remove_survey', { data: { id } });
      if (response?.data) {
        OffersStore.delete_survey(index);
      }
    } catch (error) {
      notify('error', 'Failed to remove survey');
    } finally {
      OffersStore.set_is_fetching_survey(false);
    }
  };

  const active_survey = async (
    id: string,
    workspace_id: string,
    widgetId: string,
    is_active: boolean,
    index: number,
  ) => {
    OffersStore.set_is_fetching_survey(true);
    try {
      const response = await SocketRequest('set_active_survey', {
        data: { id, workspace_id, widgetId, is_active },
      });
      if (response?.data) {
        OffersStore.update_is_active({ index, survey: response?.data });
      }
    } catch (error) {
      notify('error', 'Failed to update survey status');
    } finally {
      OffersStore.set_is_fetching_survey(false);
    }
  };
  const edit_survey = async (payload: any) => {
    OffersStore.set_is_fetching_survey(true);
    try {
      const response = await SocketRequest('edit_survey', { data: payload });
      if (response?.data) {
        OffersStore.set_edit_survey(response?.data);
      }
    } catch (error) {
      notify('error', 'Failed to edit survey');
    } finally {
      OffersStore.set_is_fetching_survey(false);
    }
  };
  const get_survey = async (id: string) => {
    OffersStore.set_is_fetching_survey(true);
    try {
      const response = await SocketRequest('get_survey', { data: id });
      if (response?.data) {
        OffersStore.set_survey(response?.data);
      }
    } catch (error) {
      notify('error', 'Failed to get survey');
    } finally {
      OffersStore.set_is_fetching_survey(false);
    }
  };

  const get_surveys = async () => {
    OffersStore.set_is_fetching_survey(true);
    try {
      const response = await SocketRequest('get_surveys', { data: {} });
      if (response?.data) {
        OffersStore.set_survey(response?.data);
      }
    } catch (error) {
      notify('error', 'Failed to get surveys');
    } finally {
      OffersStore.set_is_fetching_survey(false);
    }
  };

  return {
    get_surveys,
    get_survey,
    edit_survey,
    active_survey,
    remove_survey,
    create_survey,
    get_adverts,
    edit_advert,
    create_advert,
    remove_advert,
  };
};
